<div class="raptor-section-offramp-default-container grid">
  <div
    class="raptor-section-panel cell cell-small-col-span-6"
    [ngClass]="{
      'cell-large-col-span-12': section.settings.size !== 'small' && section.settings.size !== 'medium',
      'cell-large-col-span-8 cell-medium-col-span-6': section.settings.size === 'medium',
      'cell-large-col-start-3 cell-medium-col-start-2': section.settings.size === 'medium' && (!section.settings.align || section.settings.align === 'center'),
      'cell-large-col-start-5 cell-medium-col-start-4': section.settings.size === 'medium' && section.settings.align === 'right',
      'cell-large-col-span-6 cell-medium-col-span-4': section.settings.size === 'small',
      'cell-large-col-start-4 cell-medium-col-start-3': section.settings.size === 'small' && (!section.settings.align || section.settings.align === 'center'),
      'cell-large-col-start-7 cell-medium-col-start-5': section.settings.size === 'small' && section.settings.align === 'right'
    }"
  >

    <!-- banner -->
    <div *ngIf="section.settings.banner" [innerHTML]="section.settings.banner" class="raptor-section-banner"></div>
    <div class="raptor-section-content" [class]="sectionClass" [ngClass]="{'padding-medium': section.settings.card }">

      <div *ngIf="section.info && section.info.settings && section.info.settings.align === 'top'" class="margin-bottom-small">
        <open-raptor-info [info]="section.info" [form]="form"></open-raptor-info>
      </div>
      
      <div class="grid">
        <!-- hero image cell -->
        <!-- todo: hide this when on mobile -->
        <div
          *ngIf="heroType"
          class="raptor-section-hero cell cell-small-col-span-6"
          [ngClass]="{
            'cell-medium-col-span-2 cell-large-col-span-3': section.settings.hero
          }"
        >
          <div class="lottie-player-container" *ngIf="heroType === 'json'">
            <lottie-player [src]="section.settings.hero" background="transparent" autoplay></lottie-player>
          </div>
          <div class="lottie-player-container" *ngIf="heroType !== 'json'">
            <open-svg-icon name="{{ section.settings.hero }}" [class]="section.settings.size === 'small' ? 'small' : 'large'"></open-svg-icon>
          </div>
        </div>

        <!-- section details -->
        <div
          class="raptor-section-details-container cell cell-small-col-span-6"
          [ngClass]="{
            'cell-medium-col-span-6 cell-large-col-span-9': section.settings.hero,
            'cell-medium-col-span-8 cell-large-col-span-12': !section.settings.hero
          }"
        >
          <!-- heading -->
          <h2 *ngIf="section.heading" class="padding-bottom-xmedium">{{ section.heading }}</h2>
          <p 
            *ngIf="section.subtext"
            class="margin-bottom-xmedium" 
            [innerHTML]="section.subtext"
            [ngClass]="{
              'text-left': !section.settings || !section.settings.align || section.settings.align === 'left',
              'text-center': section.settings.align === 'center',
              'text-right': section.settings.align === 'right'
            }"
          ></p>
        </div>
      </div>

      <div 
        *ngIf="section.info && (!section.info.settings || section.info.settings.align !== 'top')"
        [ngClass]="{'margin-bottom-xmedium': section.settings && section.settings.details && section.settings.details.content}"
      >
        <open-raptor-info [info]="section.info" [form]="form"></open-raptor-info>
      </div>

      <!-- Details here -->
      <div
        *ngIf="section.settings && section.settings.details && section.settings.details.content" 
        class="grid raptor-section-details"
      >
        <div
          *ngFor="let content of section.settings.details.content"
          class="cell cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-12"
        >
          <h3 *ngIf="content.heading && content.heading !== ''" class="padding-bottom-small">{{ content.heading }}</h3>

          <p *ngIf="content.text && content.text !== ''" class="margin-bottom-medium" [innerHTML]="content.text"></p>
        </div>
      </div>

      <!-- Section disclaimer -->
      <p *ngIf="section.disclaimer && section.disclaimer.content" class="text-small" [innerHTML]="section.disclaimer.content"></p>
    </div>

  </div>
</div>
